
































import { Configuration, EntryMeetingOverview, ConferenceDoctorEntryMeetingRestControllerApi } from '@/types/api-docs'
import Utils from '@/utils/utils'
import { DataOptions, DataTableHeader } from 'vuetify'
import Vue from 'vue'
import resultStatus from '@/mixins/resultStatus'

const meetingApi = new ConferenceDoctorEntryMeetingRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

export type DataType = {
  pageName: string
  breadcrumbs: unknown[]
  overviews?: Meeting[]
  total?: number
  loading: boolean
  options: DataOptions
  headers: DataTableHeader[]
}

export type Meeting = {
  id?: number
  meetingName?: string
  eventDate?: string
  probablyAttend?: string
  actuallyAttend?: string
  meetingResultText?: string
  meetingResult?: number
}

export default Vue.extend({
  components: {},
  data(): DataType {
    return {
      pageName: Utils.replaceOrganization(Utils.switchOrganization(this.$store.getters.organization, '学術集会', 'イベント'), this.$route.meta.title),
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: Utils.replaceOrganization(Utils.switchOrganization(this.$store.getters.organization, '学術集会', 'イベント'), this.$route.meta.title),
          disabled: true,
        },
      ],
      overviews: [],
      total: 0,
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      headers: [
        { text: 'No', value: 'id', width: '5%' },
        { text: '名称', value: 'meetingName', width: '43%' },
        {
          text: '開催日',
          value: 'eventDate',
          sortable: false,
          width: '12%',
        },
        // {
        //   text: '出席カード番号',
        //   value: 'qualificationNumber',
        // },
        {
          text: '参加(予定)',
          value: 'probablyAttend',
          width: '10%',
        },
        { text: '参加(実績)', value: 'actuallyAttend', width: '10%' },
        { text: '合否', value: 'meetingResultText', width: '10%' },
        { text: '', value: 'action', sortable: false },
      ],
    }
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    async getDataFromApi() {
      this.loading = true
      const { data } = await meetingApi.fetchEntryMeetingOverviews(
        this.options.page - 1,
        this.options.itemsPerPage,
        Utils.parseSortQueryParams(this.options)
      )
      this.overviews = this.convertMeetings(data.content)
      this.total = data.totalElements
      this.loading = false
      if (data.totalPages && this.options.page > data.totalPages) {
        this.options.page = data.totalPages
      }
    },
    convertMeetings(overviews?: EntryMeetingOverview[]): Meeting[] {
      if (!overviews) {
        return []
      }
      return overviews.map((o) => {
        return {
          id: o.id,
          meetingName: o.meetingName,
          eventDate: this.generateEventDate(o.dateFrom, o.dateTo),
          actuallyAttend: o.actuallyAttend,
          probablyAttend: o.probablyAttend,
          meetingResultText: this.generateMeetingResult(o.meetingResult),
          meetingResult: o.meetingResult,
        } as Meeting
      })
    },
    generateMeetingResult(meetingResult?: number): string {
      for (const data of resultStatus.data().resultStatus) {
        if (data.value == meetingResult) {
          return data.text
        }
      }
      return ''
    },
    generateEventDate(dateFrom?: string, dateTo?: string): string | undefined {
      if (dateFrom == dateTo || !dateTo) {
        return dateFrom
      }

      return `${dateFrom} ~ ${dateTo}`
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    downloadCertificateOfCompletion(item: any) {
      window.location.href = window.location.origin + '/api/member/meetings/' + item.id + '/certificateOfCompletion'
    },
  },
})
